<template>
  <div class="pt-16">
    <v-row justify="center">
      <v-col cols="10">
        <v-img
          :src="require('@/assets/brand/logotype.png')"
          class="mb-6"
          max-width="12rem"
        />

        <div class="text-h4 text-center text-md-start primary--text mb-8">
          Bem vindo 👋
        </div>

        <v-form
          v-model="valid"
          ref="form"
          autocomplete="off"
          :disabled="loading"
        >
          <div @keypress.enter.prevent="submit()">
            <div class="primary--text">Email</div>

            <v-text-field
              v-model="form.email"
              placeholder="example@email.com"
              background-color="background2"
              :rules="_rules"
              solo
              flat
            />

            <div class="primary--text">Senha</div>

            <v-text-field
              v-model="form.password"
              placeholder="Senha"
              prepend-inner-icon="mdi-key"
              background-color="background2"
              :rules="_passwordRules"
              :append-icon="
                showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'
              "
              :type="showPassword ? 'text' : 'password'"
              solo
              flat
              @click:append="showPassword = !showPassword"
            />
          </div>

          <div class="text-right mb-6">
            <router-link to="/auth/forgot-password">
              Esqueceu sua senha?
            </router-link>
          </div>

          <v-btn
            class="text-none"
            color="primary"
            :disabled="loading"
            :loading="loading"
            depressed
            rounded
            x-large
            block
            @click="submit()"
          >
            Login
          </v-btn>
        </v-form>

        <div class="d-flex align-center my-8">
          <v-divider />

          <div class="text--secondary mx-2">ou</div>

          <v-divider />
        </div>

        <div class="text-center">
          Não possui conta?
          <router-link to="/auth/sign-up"> Cadastre-se </router-link>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { request } from "@/services";
import { handleAlert } from "@/helpers";

export default {
  name: "SignIn",

  data() {
    return {
      loading: false,
      valid: false,
      showPassword: false,
      form: {
        email: "",
        password: "",
      },
    };
  },

  watch: {
    ["form.email"](val) {
      if (val) this.form.email = val.toLowerCase();
    },
  },

  computed: {
    _rules() {
      return [(v) => !!v || "Campo Obrigatório"];
    },

    _passwordRules() {
      return [...this._rules, (v) => v.length >= 6 || "Mínimo de 6 caracteres"];
    },
  },

  methods: {
    ...mapActions(["setAccessToken"]),

    async submit() {
      if (!this.$refs.form.validate()) return;

      try {
        this.loading = true;

        const payload = {
          method: "loginUser",
          email: this.form.email,
          pass: this.form.password,
        };

        const { data } = await request(payload);

        this.setAccessToken(data.authToken);
        this.$root.$emit("get-user", true);
      } catch (error) {
        this.handleAlert(error.data.message, "error");
      } finally {
        this.loading = false;
      }
    },

    handleAlert,
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
